export default __webpack_public_path__ + "static/BarbaraGrant-e0321c668fc5e298ac16fc1b6c44c563.jpg";